'use strict';

import { Utils } from 'poly-js-utils';

/*
    formatProfileButtonUrl–
    * if a url includes a hash or a telephone link it's returned as is, otherwise the baseLink is prepended
    * the baseLink will be an empty string if the link is external
*/

export function formatProfileButtonUrl(baseLink, button) {
    const buttonType = Array.isArray(button.type) && button.type.length !== 0 ? button.type[0] : 'link';
    const buttonUrl = button.url;

    switch (buttonType) {
        case "link": {
            const prependedUrl = Utils.selectBoxIsTrue(button.is_external) ? '' : baseLink;
            const isNotAbsoluteLink = buttonUrl.includes('#') ||
                buttonUrl.includes('tel:') ||
                buttonUrl.includes('mailto:');
            return isNotAbsoluteLink ? buttonUrl : `${prependedUrl}${buttonUrl}`;
        }
        case "email": {
            if (buttonUrl.includes('mailto:')) {
                return buttonUrl;
            }
            return `mailto:${buttonUrl}`;
        }
        case "telephone": {
            if (buttonUrl.includes('tel:')) {
                return buttonUrl;
            }
            return `tel:${buttonUrl}`;
        }
    }
}



// WEBPACK FOOTER //
// ./components/profile/selectors.js